/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbstractLeafOperandValueImpl } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/AbstractLeafOperandValueImpl";
import { ExpExpressionNodeNodeTypeEnum } from "abweb/generated/abwebinternal/api/dto/ExpExpressionNode";
import { Assert } from "abweb/utils/Assert";
import Immutable from "immutable";
// import WithoutNodeType = GuidedExpressionEditor.AbstractModel.AbstractRowModel.AbstractOperandValue.WithoutNodeType;
// import ReferenceOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.ReferenceOperandValue;

export class ReferenceOperandValueImpl extends AbstractLeafOperandValueImpl {
  constructor(stateWithoutNodeType) {
    super({
      expExpressionNodeNodeType: ExpExpressionNodeNodeTypeEnum.REFERENCE,
      ...stateWithoutNodeType
    });
  }
}
(function (_ReferenceOperandValueImpl) {
  function fromExpTemplateConfiguration(id, operandName, expTemplateConfiguration, expressionDomainModel) {
    const {
      categoryID,
      valueTypeID,
      multiple
    } = expTemplateConfiguration;
    Assert.assert(categoryID != null && valueTypeID != null);
    const expValueCategory = expressionDomainModel.getExpValueCategory(categoryID);
    const expValueType = expressionDomainModel.getExpValueType(valueTypeID);
    const value = `${expValueCategory.label} (${expValueType.label}${multiple ? "[]" : ""})`;
    return new ReferenceOperandValueImpl({
      id: id,
      operandName: operandName,
      valueCategoryID: categoryID,
      valueTypeIDs: Immutable.List.of(valueTypeID),
      multiple: multiple ?? false,
      value: value,
      displayValue: value
    });
  }
  _ReferenceOperandValueImpl.fromExpTemplateConfiguration = fromExpTemplateConfiguration;
})(ReferenceOperandValueImpl || (ReferenceOperandValueImpl = {}));
//# sourceMappingURL=ReferenceOperandValueImpl.js.map
